import React from 'react';

export const Options = ({ color = '#24252C' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="4" r="1" fill={color} />
    <circle cx="8" cy="8" r="1" fill={color} />
    <circle cx="8" cy="12" r="1" fill={color} />
  </svg>
);
